import { useAuthStore } from '@/store/useAuthStore';

export function useAuth() {
  const {
    token,
    user,
    isLoading,
    error,
    login,
    fetchProfile,
    logout,
    clearError,
  } = useAuthStore();

  const isAuthenticated = !!token;

  return {
    token,
    user,
    isLoading,
    error,
    isAuthenticated,
    login,
    fetchProfile,
    logout,
    clearError,
  };
}